'use strict';

var _ = require('lodash');
var MarketsFilterByPOSFactory = function MarketsFilterByPOSFactory(DataFilter) {
  function MarketsFilterByPOS() {
    DataFilter.call(this, 'market-dashboard', 'markets-and-poses', 2);
  }
  MarketsFilterByPOS.prototype = Object.create(DataFilter.prototype);
  MarketsFilterByPOS.prototype.filter = function (data, range) {
    range = range[0];
    return _.isArray(range.pos) ? DataFilter.prototype.filter(data, range.pos, 'pos') : data;
  };
  return MarketsFilterByPOS;
};
MarketsFilterByPOSFactory.$inject = ['DataFilterFactory'];
module.exports = MarketsFilterByPOSFactory;